module.exports = __webpack_public_path__ + "img/zsgg-13.ae55ddcc.png";